import {commercialWebsocketCommands} from '../../constants/commercialWebsocketCommands';
import {extractErrorText} from '../actionUtils';
import {errorAlert} from '../alertsActions';
import {uploadCommercialAttachment} from '../../api/commercial/restCommercialAttachment';
import alertMessages from '../../intl/common/alertMessages';

export const COMMERCIAL_ATTACHMENTS_UPLOADING_ERROR = 'COMMERCIAL_ATTACHMENTS_UPLOADING_ERROR';
export const COMMERCIAL_ATTACHMENTS_UPLOADING = 'COMMERCIAL_ATTACHMENTS_UPLOADING';

export const startUploadingCommercialAttachments = () => dispatch => {
    return dispatch({type: COMMERCIAL_ATTACHMENTS_UPLOADING});
};

export const downloadCommercialAttachment = (uuid, ticketId, name) => dispatch => {
    return dispatch({
        type: commercialWebsocketCommands.COMMERCIAL_DOWNLOAD_PRESIGNED_URL,
        commercialWebsocket: true,
        command: commercialWebsocketCommands.COMMERCIAL_DOWNLOAD_PRESIGNED_URL,
        payload: {
            attachment: {
                uuid,
                ticketId,
                name
            }
        }
    });
};

export const uploadCommercialAttachments = (attachments, correlationId) => dispatch => {
    const promises = [];
    const savedAttachments = [];
    attachments.forEach(attachment => {
        promises.push(
            uploadCommercialAttachment(attachment.url, attachment.localUrl, attachment.name, attachment.contentType).then(
                () => {
                    window.URL.revokeObjectURL(attachment.localUrl);
                    savedAttachments.push(attachment);
                }, error => {
                    dispatch({type: COMMERCIAL_ATTACHMENTS_UPLOADING_ERROR});
                    dispatch(errorAlert(...extractErrorText(error, alertMessages.FILE_UPLOAD_ERROR)));
                }
            )
        )
    });

    return Promise.all(promises).then(() => {
            if (savedAttachments.length > 0) {
                dispatch({
                    type: commercialWebsocketCommands.COMMERCIAL_CREATE_ATTACHMENT,
                    commercialWebsocket: true,
                    command: commercialWebsocketCommands.COMMERCIAL_CREATE_ATTACHMENT,
                    payload: {
                        attachments: savedAttachments,
                        correlationId,
                        uuid: savedAttachments[0].ticketId,
                    }
                })
            } else {
                dispatch({
                    type: COMMERCIAL_ATTACHMENTS_UPLOADING_ERROR,
                })
            }
        }
    );
};
